import { useEffect, useState } from "react";

import { translate } from "@utils";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export const PolicyFormTrueOrFalse = ({ viewOnly = false, label, keyName, activePolicy, setActivePolicy }) => {
	const [selection, setSelection] = useState(activePolicy[keyName] ? "true" : activePolicy[keyName] === null ? "" : "false");

	useEffect(() => {
		if (selection === "") {
			setActivePolicy((prevState) => ({ ...prevState, [keyName]: null }));
		} else {
			setActivePolicy((prevState) => ({ ...prevState, [keyName]: selection === "true" }));
		}
	}, [selection]);

	const handleSelection = (e) => {
		setSelection(e.target.value);
	};

	return (
		<FormControl>
			<InputLabel id={`cvePolicyForm-${label}`}>{translate(label)}</InputLabel>
			<Select disabled={viewOnly} style={{ minWidth: "150px" }} labelId={`cvePolicyForm-${label}`} value={selection} label={translate(label)} onChange={handleSelection}>
				<MenuItem value={""}>{translate("either")}</MenuItem>
				<MenuItem value="true">{translate("true")}</MenuItem>
				<MenuItem value="false">{translate("false")}</MenuItem>
			</Select>
		</FormControl>
	);
};
